module.exports = __webpack_public_path__ + "img/PAMMHeadModelM.29e65f7b.png";